module.exports = __webpack_public_path__ + "static/media/eye.0bb75f29.svg";